<p-dialog [(visible)]="visible" 
  [modal]="true" 
  [closable]="true" 
  header="Red Curve Solutions® Account" 
  styleClass="p-dialog-centered p-dialog-sm" >
  
  <div class="content">
    <h3>Access to RCS SaaS Services requires company authorization</h3>
    <p>
      Please contact your campaign representative to receive an invitation for a new user account.
    </p>
    <hr class="my-4" />
    <h5>Contact Us</h5>
    <p>
      <strong>Red Curve Solutions, LLC</strong><br />
      138 Conant Street, 2<sup>nd</sup> Floor<br />
      Beverly, MA 01915
    </p>
    <p>
      <strong>Phone:</strong> 617-303-6800<br />
      <strong>E-mail:</strong> <a href="mailto:client&#64;redcurve.com" class="inline-block ml-1">client&#64;redcurve.com</a>
    </p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton label="Close" (click)="closeModal($event)"></button>
  </ng-template>
</p-dialog>
